import { render, staticRenderFns } from "./OneProduct.vue?vue&type=template&id=a58af0cc&"
import script from "./OneProduct.vue?vue&type=script&lang=js&"
export * from "./OneProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports